import { CoreIcon } from '../core-icon';
import bankJcbSquareSVG from '../../assets/logos/bank-jcb-square.svg';
import type { IconProps } from '../core-icon';

export const BankJcbSquareIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={bankJcbSquareSVG} {...props} />;
};
